import thumbnail from './treemapchart_thumb.svg';

export const metadata = {
  name: 'global.section.chartselection.treemapchart.title',
  thumbnail,
  icon: 'fa-chart-tree-map',
  id: 'treemap',
  categories: ['categories.hierarchy', 'categories.proportions'],
  description: 'global.section.chartselection.treemapchart.description',
  code: '',
  tutorial: '',
};
